export default "__VITE_ASSET__CBLwbBwq__"